// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__5kz5-","label":"SetPasswdForm_label__28WZy"};